import Bugsnag from '@bugsnag/js';

export function setSessionStorageItem(name: string, value: string) {
    try {
        sessionStorage.setItem(name, value);
    } catch (error) {
        Bugsnag.notify(error, (event) => {
            event.context = `Failed to set session storage item for: ${name}`;
        });
    }
}

export function getStateFromSessionStorage(key: string) {
    try {
        const item = sessionStorage.getItem(key);

        return item ? JSON.parse(item) : null;
    } catch (error) {
        return null;
    }
}
